window.stylePopup = {

	local : null,

	iframe : null,
	target : null,
	timer : null,
	isopend : false,

	open : {
		el : null,
		iframe : null,
		password : null,
		click : null
	},

	close : {
		el : null,
		click : null
	},

	once(){

		//
		this.target = document.querySelector('.js-iframe-target');
		this.close.el = document.querySelector('.js-close-popup');

		//
		this.close.click = (e) =>{
			e.preventDefault();
			this.onClose();
		}
		this.close.el.addEventListener('click',this.close.click);

	},

	onInit( elem ){

		this.local = !elem ? document : elem;
	
		//
		this.open.el = this.local.querySelector('.js-open-popup');
		if( this.open.el ){
			this.open.password = this.open.el.dataset.password;
			this.open.iframe = this.open.el.dataset.iframe;
			this.open.click = (e) => {
				e.preventDefault();
				this.onOpen();
				this.onBuildIframe();
			}
			this.open.el.addEventListener('click',this.open.click);
		}

	},

	onBuildIframe(){

		this.target.innerHTML = this.open.iframe;
		// const $iframe = this.target.querySelector('iframe');
		// const w = $iframe.getAttribute('width') ? Number( $iframe.getAttribute('width') ) : 1920;
		// const h = $iframe.getAttribute('height') ? Number( $iframe.getAttribute('height') ) : 1080;
		// this.target.style.aspectRatio = w+'/'+h;

	},

	onOpen(){
		this.isopend = true;
		$html.classList.add('is-o-pp');
		if( this.open.password ){
			$html.classList.add('is-o-pwd');
		}
	},

	onClose(){
		this.isopend = false;
		$html.classList.remove('is-o-pp','is-o-pwd');
		this.target.innerHTML = '';
	},

	onDestroy(){
		this.onClose();
		if( this.open.click ){
			this.open.el.removeEventListener('click',this.open.click);
			this.open.el = null;
			this.open.click = null;
			this.open.mouseenter = null;
			this.open.mouseleave = null;
		}
	}

}

stylePopup.once();
















